const RULE_MESSAGES = {
	min: "At least 8 characters",
	max: "At most 64 characters",
	uppercase: "At least one uppercase letter (A–Z)",
	lowercase: "At least one lowercase letter (a–z)",
	digit: "At least one digit (0–9)",
	symbol: "At least one symbol (e.g. ! @ # $ % & *)",
}

const BANNED = ["passw0rd", "password123", "password", "ert", "orixe"]
const REPEATED_CHAR = /(.)\1{3,}/
const SEQUENTIAL_DIGITS = /^(012|123|234|345|456|567|678|321|432|543|654|765|876|987)/

export const PASSWORD_REQUIREMENTS = [
	RULE_MESSAGES.min,
	RULE_MESSAGES.max,
	RULE_MESSAGES.uppercase,
	RULE_MESSAGES.lowercase,
	RULE_MESSAGES.digit,
	RULE_MESSAGES.symbol,
	"Cannot be a common password (e.g. Password123)",
	"Cannot contain 4+ repeated characters or simple digit sequences",
]

/** Whether a single requirement line is met (for live checklist UI). */
export function isRequirementMet(reqText, password) {
	const p = password || ""
	if (reqText === RULE_MESSAGES.min) return p.length >= 8
	if (reqText === RULE_MESSAGES.max) return p.length <= 64
	if (reqText === RULE_MESSAGES.uppercase) return /[A-Z]/.test(p)
	if (reqText === RULE_MESSAGES.lowercase) return /[a-z]/.test(p)
	if (reqText === RULE_MESSAGES.digit) return /[0-9]/.test(p)
	if (reqText === RULE_MESSAGES.symbol) return /[^A-Za-z0-9]/.test(p)
	if (reqText.includes("common password")) {
		return !BANNED.includes(p.toLowerCase())
	}
	if (reqText.includes("repeated") || reqText.includes("digit sequences")) {
		return !REPEATED_CHAR.test(p) && !SEQUENTIAL_DIGITS.test(p)
	}
	return null
}

export function getPasswordValidationErrors(password) {
	if (!password || typeof password !== "string") {
		return ["Password is required."]
	}
	const errors = []
	if (password.length < 8) errors.push(RULE_MESSAGES.min)
	if (password.length > 64) errors.push(RULE_MESSAGES.max)
	if (!/[A-Z]/.test(password)) errors.push(RULE_MESSAGES.uppercase)
	if (!/[a-z]/.test(password)) errors.push(RULE_MESSAGES.lowercase)
	if (!/[0-9]/.test(password)) errors.push(RULE_MESSAGES.digit)
	if (!/[^A-Za-z0-9]/.test(password)) errors.push(RULE_MESSAGES.symbol)
	if (BANNED.includes(password.toLowerCase())) errors.push("Password is too simple or commonly used.")
	if (REPEATED_CHAR.test(password)) errors.push("Cannot contain 4+ repeated characters in a row")
	if (SEQUENTIAL_DIGITS.test(password)) errors.push("Cannot start with simple sequential digits")
	return errors
}

export function isPasswordValid(password) {
	return getPasswordValidationErrors(password).length === 0
}

export function passwordRules() {
	return [
		(v) => !!v || "Password is required.",
		(v) => {
			const errors = getPasswordValidationErrors(v)
			return errors.length === 0 || errors[0]
		},
	]
}

export function matchPasswordRule(otherPassword) {
	return (v) => v === otherPassword || "Passwords do not match."
}
